export default "__VITE_ASSET__BGLcScZN__"